export const routes = {
  HOME: '/',
  PRIVACY_POLICY: '/privacy-policy',
  LOGIN: '/login',
  TWO_FA_LOGIN: '/two-fa',
  CREATE_TWO_FA: '/create-two-fa',
  CONTACT: '/contact',
  CREATE_COMPANY: '/create-company',
  ONBOARDING: '/onboarding',
  TRADING: '/trading/',
  ACCOUNT_ADMIN: '/trading/admin-account',
  ACCOUNT_USER: '/trading/user-account/:id',
  TREASURY: '/trading/treasury',
  VIEW_ALL_TRANSACTIONS: '/trading/treasury/view-all-transactions',
  VIEW_ALL_TRANSACTIONS_BY_ID: '/trading/treasury/view-all-transactions/:id',
  VIEW_ALL_TRADES: '/trading/treasury/view-all-trades',
  VIEW_ALL_TRADES_BY_ID: '/trading/treasury/view-all-trades/:id',
  STAKING: '/trading/staking',
  COMPANY_ONBOARDING: '/company/:uniqKey/onboarding',
  USER_ONBOARDING: '/user/:uniqKey/onboarding',
  SPOT_TRADING: '/trading/spot_trading',
  PORTFOLIO: '/trading/portfolio',
  PORTFOLIO_FIAT: '/trading/portfolio/fiat',
  PORTFOLIO_CRYPTO: '/trading/portfolio/crypto',
  USER_REQUEST_RESET_PASSWORD: '/reset-password',
  USER_RESET_PASSWORD: '/user/:userIdReference/password/reset',
  FILES_MTA: '/files/MTA.pdf',
  FILES_PRIVACY_POLICY: '/files/Privacy_Policy.pdf',
}
